export default {"src":"/_next/static/media/SubDesc6.7e5fd006.svg","height":121,"width":120,"blurWidth":0,"blurHeight":0};